import React from "react";
import Card from "components/card";
// import Checkbox from "components/checkbox";
import moment from "moment"

export default function UserTable({ tableData, filters, setFilters, handleSearch, setFilterClear }) {


    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6 pb-5"}>
            <header className="relative flex flex-col gap-4 pt-4">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Users
                </div>

                {/* Filter UI */}
                <div className="flex flex-wrap items-center justify-between gap-4">
                    <div className="flex flex-wrap gap-3">
                        <input
                            type="text"
                            placeholder="Search by name"
                            value={filters.search}
                            onChange={(e) => handleFilterChange("search", e.target.value)}
                            className="rounded border px-3 py-1 text-sm dark:!bg-white/5"
                        />
                        <select
                            value={filters.status}
                            onChange={(e) => handleFilterChange("status", e.target.value)}
                            className="rounded border px-3 py-1 text-sm dark:!bg-white/5"
                        >
                            <option value="all">All</option>
                            <option value="active">Active</option>
                            <option value="draft">Draft</option>
                        </select>
                        {/* <input
              type="date"
              value={filters.date}
              onChange={(e) => handleFilterChange("date", e.target.value)}
              className="rounded border px-3 py-1 text-sm dark:!bg-white/5"
            /> */}
                    </div>

                    <div className="flex gap-3">
                        <button
                            onClick={() => handleSearch()}
                            className="rounded-md border border-brand-500 px-4 py-1.5 text-sm font-semibold text-brand-500 hover:bg-brand-50 transition"
                        >
                            Search
                        </button>

                        {/* Clear Filters Button */}
                        <button
                            onClick={() => {
                                setFilters({
                                    search: "",
                                    status: "",
                                })
                                setFilterClear(true)
                            }}
                            className="rounded-md bg-brand-500 px-4 py-1.5 text-sm font-semibold text-white shadow transition hover:bg-brand-600"
                        >
                            Clear Filters
                        </button>
                    </div>
                </div>
            </header>

            {/* Table */}
            <div className="mt-6 overflow-x-scroll xl:overflow-x-hidden">
                <table className="w-full">
                    <thead>
                        <tr className="!border-px !border-gray-400">
                            {["NAME", "EMAIL", "CREATED AT", "STATUS"].map((head) => (
                                <th
                                    key={head}
                                    className="cursor-pointer border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start text-sm font-bold text-gray-600 dark:text-white"
                                >
                                    {head}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData?.map((item, index) => (
                            <tr key={index}>
                                <td className="min-w-[150px] py-3 pr-4">
                                    <div className="flex items-center">
                                        {/* <Checkbox defaultChecked={item.name[1]} me="10px" /> */}
                                        <p className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                                            {item.fullName}
                                        </p>
                                    </div>
                                </td>
                                <td className="min-w-[100px] py-3 pr-4">
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {item.email}
                                    </p>
                                </td>
                                <td className="min-w-[100px] py-3 pr-4">
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {moment(item.createdAt)?.format("DD/MM/YYYY")}
                                    </p>
                                </td>
                                <td className="min-w-[120px] py-3 pr-4">
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {item.isVerified ? "Active" : "Draft"}
                                    </p>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card>
    );
}
